import { m } from "@/paraglide/messages.js";
import { agentDefinitionQueryOptions } from "@/services/agent-definitions-service.ts";
import { createEntityErrorBoundary } from "@/utils/entity-error-boundary.tsx";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { z } from "zod";
import { RoutePending } from "@/components/custom/route-pending.tsx";

export const Route = createFileRoute(
	"/_authenticated/dashboard/agents/$agentId",
)({
	loader: async ({ params, context: { queryClient } }) => {
		// Validate here (not in params.parse) so a malformed id throws inside the
		// loader, where the route's errorComponent catches it — param-parse throws
		// happen during matching and escape to the global boundary instead.
		z.uuid().parse(params.agentId);
		await queryClient.ensureQueryData(
			agentDefinitionQueryOptions(params.agentId),
		);
	},
	errorComponent: createEntityErrorBoundary({
		title: m.agent_builder_not_found_title,
		description: m.agent_builder_not_found_description,
		backLabel: m.agent_builder_not_found_back,
		backTo: "/dashboard/agents",
	}),
	component: Outlet,
	pendingComponent: RoutePending,
});
